export const localStorageUsername = localStorage.getItem("__extraconomy_username");

export const removelocalStorageUsername = () => localStorage.removeItem("__extraconomy_username");
